export default "__VITE_ASSET__BrhWzn4a__"